<template>
  <div class="content">
    <!-- 新增按钮 -->
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item>
        <el-button type="primary" @click="kaihuBtn">新增</el-button>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <div style="height: 80%">
      <el-table
        :data="beforArr"
        style="width: 100%"
        height="100%"
        v-loading="loading"
        :header-cell-style="{ background: '#e8effc', color: '#000' }"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column label="文章封面图" width="100" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.url" alt style="width: 100%" />
          </template>
        </el-table-column>
        <el-table-column label="文章标题" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column label="链接" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.link }}</span>
          </template>
        </el-table-column>
        <el-table-column label="文章描述" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.detail }}</span>
          </template>
        </el-table-column>
        <el-table-column label="排序(从小到大排序)" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.sort }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="ejectupdataGoods(scope.row)"
              >修改</el-button
            >
            <el-button size="mini" type="danger" @click="deleteAdmin(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 新增表单 -->
    <el-dialog :title="inputTitle" :visible.sync="dialogFormVisible" :close-on-click-modal='false'>
      <el-form :model="form">
        <el-form-item label="标题">
          <el-input v-model="form.title" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="描述文字">
          <el-input type="textarea" v-model="form.detail" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="链接">
          <el-input v-model="form.link" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="form.sort" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <el-upload
        class="upload-demo"
        :action="action"
        :multiple="true"
        :on-success="handleSuccess_cover"
        :file-list="fileList"
        list-type="picture"
        name="formData"
      >
        <el-button size="small" type="primary">点击上传图片(1张)</el-button>
        <div slot="tip" class="el-upload__tip">
          只能上传jpg/png文件，750px X 300px
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbmitBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectArticle,
  addArticle,
  updateArticle,
  deleteArticle,
} from "@/services/article";
export default {
  data() {
    return {
      beforArr: [],
      inputTitle: "新增",
      cover: "",
      fileList: [],
      action: "https://mini-xili.bboycc.cn/uploadFile/add",
      loading: true,
      name: "",
      pageCount: "",
      pageSize: 8,
      adminArr: [
        { name: "最高权限", id: "0" },
        { name: "普通子账号权限", id: "1" },
      ],
      form: {},
      dialogFormVisible: false,
    };
  },
  created() {
    // 查询用户登陆数据
    this.selece();
  },
  methods: {
    // 查询
    selece() {
      selectArticle().then((resp) => {
        console.log(resp.data);
        this.loading = false;
        this.beforArr = resp.data;
        // this.$message({
        //   type: "success",
        //   message: "跟新成功!"
        // });
        // this.pageCount = resp.pageCount;
      });
    },
    // 新增按钮
    kaihuBtn() {
      this.inputTitle = "新增";
      this.dialogFormVisible = true;
      this.form = {};
    },
    ejectupdataGoods(row) {
      console.log(row);
      this.form = {};
      this.dialogFormVisible = true;
      this.inputTitle = "修改";
      this.form = JSON.parse(JSON.stringify(row));
    },
    handleSuccess_cover(e) {
      console.log(e.data);
      this.form.url = e.data;
      console.log(this.form);
    },
    // 表单提交按钮
    sumbmitBtn() {
      console.log(this.form);
      if (this.form.url == "" || this.form.url == null) {
        this.$message.error("请上传文章封面图");
        return;
      }
      if (this.form.title == "" || this.form.title == null) {
        this.$message.error("请填写文章标题");
        return;
      }
      if (this.form.detail == "" || this.form.detail == null) {
        this.$message.error("请填写文章描述");
        return;
      }
      if (this.form.sort == "" || this.form.sort == null) {
        this.form.sort = 0;
      }
      if (this.form.link == "" || this.form.link == null) {
        this.form.link = "";
      }
      if (this.inputTitle == "新增") {
        addArticle(this.form).then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.dialogFormVisible = false;
            this.$message({
              type: "success",
              message: "新增文章成功!",
            });
            this.selece();
          } else {
            this.$message({
              type: "info",
              message: "网路错误",
            });
          }
        });
        return;
      }

      updateArticle(this.form).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.dialogFormVisible = false;
          this.$message({
            type: "success",
            message: "修改成功!",
          });
          this.selece();
        } else {
          this.$message({
            type: "info",
            message: "网络错误",
          });
        }
      });
    },
    // 删除
    deleteAdmin(row) {
      this.$confirm("此操作将永久删除该账号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(row.id);
          deleteArticle(row.id).then((resp) => {
            console.log(resp);
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.selece();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style>
.content {
  margin: 30px auto;
  /* border:1px solid red; */
  width: 80%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.userNanme:hover {
  cursor: pointer;
}
</style>